import { useI18n } from "vue-i18n";
import { useProfileStore } from "@/modules/settings/public";
import { formatDateTime, isoToDisplayDate } from "@/shared/utils/date-formatting";
/**
 * Date formatters for the donation history values, in the profile format (R30): a calendar day as
 * the Details tab shows the donation date, an instant as the history's "Modifié le" column.
 */
export function useHistoryDateFormatters() {
    const { locale } = useI18n();
    const profileStore = useProfileStore();
    return {
        day: (calendarDay) => isoToDisplayDate(calendarDay, profileStore.profile?.dateFormat, locale.value),
        instant: (isoInstant) => formatDateTime(isoInstant, locale.value, profileStore.profile?.dateFormat, profileStore.profile?.timeFormat),
    };
}
